const applyStyles = () => {
  // Try regular DOM first
  let selectors = document.querySelectorAll('div.rc-purchase-option__selector');
  let badges = document.querySelectorAll('.rc-purchase-option__badge');
  
  // If not found, try shadow DOM
  if (selectors.length === 0 || badges.length === 0) {
    const container = document.querySelector('recharge-subscription-widget');
    if (container && container.shadowRoot) {
      if (selectors.length === 0) {
        selectors = container.shadowRoot.querySelectorAll('div.rc-purchase-option__selector');
      }
      if (badges.length === 0) {
        badges = container.shadowRoot.querySelectorAll('.rc-purchase-option__badge');
      }
    }
  }
  
  let applied = false;
  
  if (selectors.length > 0) {
    selectors.forEach(selector => {
      selector.style.setProperty('font-size', '1rem', 'important');
    });
    console.log(`Style applied to ${selectors.length} rc-purchase-option__selector element(s)`);
    applied = true;
  }
  
  if (badges.length > 0) {
    badges.forEach(badge => {
      badge.style.setProperty('font-family', 'Mono', 'important');
      badge.style.setProperty('text-transform', 'uppercase', 'important');
    });
    console.log(`Style applied to ${badges.length} rc-purchase-option__badge element(s)`);
    applied = true;
  }
  
  return applied;
};

// Check every 100ms
const checkInterval = setInterval(() => {
  if (applyStyles()) {
    clearInterval(checkInterval);
  }
}, 100);

// Stop trying after 10 seconds
setTimeout(() => {
  clearInterval(checkInterval);
  console.log('Stopped checking for rc-purchase-option elements');
}, 10000);


const addReadMore = () => {
  const parentBlock = document.querySelector('#sf-custom__block--text_h6MtKd');
  
  if (!parentBlock) return false;
  
  const metafieldsList = parentBlock.querySelector('ul.metafield-single_line_text_field-array');
  
  if (!metafieldsList) return false;
  
  const items = metafieldsList.querySelectorAll('li.metafield-single_line_text_field');
  
  // Only add read more if there are more than 3 items
  if (items.length <= 5) return true;
  
  // Check if already processed
  if (metafieldsList.dataset.readMoreAdded) return true;
  
  // Hide items after the 3rd one
  items.forEach((item, index) => {
    if (index >= 4) {
      item.style.display = 'none';
    }
  });
  
  // Create read more button
  const readMoreBtn = document.createElement('button');
  readMoreBtn.textContent = 'READ MORE';
  readMoreBtn.style.marginTop = '10px';
  readMoreBtn.style.textDecoration = 'underline';
  
  // Add click handler
  readMoreBtn.addEventListener('click', () => {
    items.forEach((item, index) => {
      if (index >= 3) {
        item.style.display = '';
      }
    });
    readMoreBtn.remove();
  });
  
  // Insert button after the list
  metafieldsList.parentElement.appendChild(readMoreBtn);
  metafieldsList.dataset.readMoreAdded = 'true';
  
  console.log(`Read more button added (hiding ${items.length - 3} items)`);
  return true;
};

// Check every 100ms
const readMoreInterval = setInterval(() => {
  if (addReadMore()) {
    clearInterval(readMoreInterval);
  }
}, 100);

// Stop trying after 10 seconds
setTimeout(() => {
  clearInterval(readMoreInterval);
  console.log('Stopped checking for metafields list');
}, 10000);
// Listen for changes in the second radio button group
// var secondGroup = document.querySelectorAll('input[name="Size"]');

// for (var i = 0; i < secondGroup.length; i++) {
//     secondGroup[i].addEventListener('change', function () {
//         // Add a 2-second delay using setTimeout
//         setTimeout(function () {
//             // Find all radio buttons in the "purchaseOption" group
//             var purchaseOptions = document.querySelectorAll('input[name="purchaseOption"]');
//             for (var j = 0; j < purchaseOptions.length; j++) {
//                 // You can access each radio button in this loop
//                 var radioButton = purchaseOptions[j];
//                 //console.log('Name: ' + radioButton.getAttribute('name') + ', Value: ' + radioButton.value);
//             }

//             // Select the first radio button in the "purchaseOption" group
//             var firstOption = purchaseOptions[0];

//             // Trigger a click action on the label associated with the first radio button
//             var firstOptionLabel = document.querySelector('label[for="' + firstOption.id + '"]');
//             firstOptionLabel.click();
//         }, 500);
//     });
// }
/*
document.addEventListener("DOMContentLoaded", function() {
    const addToCartForm = document.querySelector(".product-addon form");
    
    if (addToCartForm) {
      addToCartForm.addEventListener("submit", function(event) {
        event.preventDefault();
        const formData = new FormData(addToCartForm);
        const object = {}
        formData.forEach((value, key) => object[key] = parseInt(value));
        // var items = JSON.stringify(object);
        // console.log(items)
        
        // Use Shopify's AJAX API to add the product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [
                object
            ]
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log("data:", data.status)
        //window.Shopify.onCartUpdate()
        if (data.status == 200) {
          // Successfully added to the cart, you can redirect to the cart page or update the cart icon
          //window.location.href = '/cart'; // Redirect to the cart page
          alert("added")
          console.log("added")
        } else {
          // Handle errors
          console.error('Failed to add the product to the cart.');
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
    }
  });*/

  window.onload = function () {
  // Remove the "stuck" class from elements
  setTimeout(function () {
    function removeStuckClass() {
      const stuckElements = document.querySelectorAll(".stuck");
      stuckElements.forEach(function (element) {
        element.classList.remove("stuck");
      });
    }
    // Call the function on page load
    removeStuckClass();
  }, 150)

  const giftOrderCheckbox = document.getElementById("giftOrderCheckbox");
  //console.log("giftOrderCheckbox:", giftOrderCheckbox)
    if (giftOrderCheckbox) {
      giftOrderCheckbox.addEventListener("change", function () {
        const isGiftOrder = giftOrderCheckbox.checked;
        //console.log("isGiftOrder:", isGiftOrder)
        var noteText = "";
        
        // Update the cart note based on the checkbox state
        if( isGiftOrder === true )
          noteText = "This is a gift order";
        else 
          noteText = null;

        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          note: noteText
        })

      });
    }
};


// Function to check if a product title contains "MD03"
function containsMD03(item) {
  console.log("item: ", item)
  var md03Exists = false;
  if(item.handle.includes("md-03-upgrade"))
    md03Exists = true;
  else if (item.handle.includes("skin-optimizing-protocol") && !item.variant_title.includes("1 Pack ($100 off)"))
    md03Exists = true;
  return md03Exists;
}

function containsAddOn(item) {
  //console.log("item.title: ", item.title)
  if (item.title.includes("(MD-03)") || item.variant_title.includes("1 Pack ($100 off)"))
    return true;
  return false;
}

// Function to remove products containing "MD03" from the cart
function removeMD03Products(cart) {
  var updates = {}
  var hasAddon = false;
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    //console.log("Add on?:", containsAddOn(item.title))
    if (containsAddOn(item)) {
      //console.log(item.variant_id)
      updates[item.variant_id] = 0;
      hasAddon = true;
    }
  }
  // Update the cart with the filtered items
  //console.log("updates: ", updates)
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      if(hasAddon){
        setTimeout(function(){
          window.location.href = location.href;
        }, 500)
      }
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    // location.reload()
}

// Function to handle cart updates
function handleCartUpdate(cart) {
  var md03Exists = false;
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    if (containsMD03(item)) {
      md03Exists = true;
      break;
    }
  }
  if (!md03Exists) {
    console.log("No MD-03, clearing cart")
    //console.log("No Md03, removing add ons");
    removeMD03Products(cart); 
  }
}

// Listen for cart updates
Shopify.onCartUpdate = function(cart) {
  // alert("updated")
  handleCartUpdate(cart)
};

var metafieldLi = document.getElementsByClassName("metafield-single_line_text_field")
// var metafieldMultiLine = document.getElementById("expandable-content")
var metafieldText = "";
var newList = "";
var finalList = "";
if( metafieldLi ){
  for(i=0; i<metafieldLi.length; i++){
    metafieldText = metafieldLi[i].innerHTML;
    metafieldText = metafieldText.split(":")
    if(metafieldText.length > 1){
      newList = "<strong>" + metafieldText[0] + ":</strong>" + metafieldText.slice(1);
      // newList = newList.replace(",")
      var splitList = newList.split("**")
      if(splitList.length > 1){
        console.log("in ** split")
        // console.log("splitList", splitList)
        finalList = splitList[0];
        for(j=1; j<splitList.length; j++){
          finalList = finalList + '<li class="metafield-list-split">'+splitList[j]+'</li>'
        }
        metafieldLi[i].innerHTML = finalList;
      }
      else
        metafieldLi[i].innerHTML = newList;
    }
  }
}

var sliderNav = document.getElementsByClassName("pf-slider-nav pagination-style-2")[0];
if(sliderNav != null ){
  var sliderNavbuttons = Array.from(sliderNav.children);
  sliderNavbuttons.forEach(function(current, index){
    current.setAttribute("aria-label", "Slide" + index)
  })
}

//console.log("sliderNavbuttons", sliderNavbuttons)



// Change to your STICKY element
// let parent = document.querySelector('.menu-pdp').parentElement;
    
// while (parent) {
//     const hasOverflow = getComputedStyle(parent).overflow;
//     if(hasOverflow !== 'visible') {
//         console.log(hasOverflow, parent);
//     }
//     parent = parent.parentElement;
// }

// function updatenote(itemId, variantId, itemQty, e) {
//   // alert("submitted")
//   e.preventDefault();
//   const qty = itemQty;
//   const productData = {
//     productID: itemId,
//     variantId: variantId,
//   };
//   const button = e.target;
//   button.disabled = true;
//   console.log("button: ",button)
//   const userData = [];
//   var currentNote = "";
//   let currentData = [];
//   let email = null;
//   let firstName = null;
//   let lastName = null;
//   let emptyFlag = true;

//   // Collect email and first name pairs
//   for (let i = 1; i <= qty; i++) {
//     email = document.getElementById("email-" + itemId + "-" + i).value.trim();
//     firstName = document.getElementById(
//       "firstName-" + itemId + "-" + i
//     ).value.trim();
//     lastName = document.getElementById(
//       "lastName-" + itemId + "-" + i
//     ).value.trim();
//     console.log("email", email)
//     if( email != null && email != "" )
//       userData.push({ email: email, firstName: firstName, lastName: lastName });    
//     const newData =
//       {
//         product: productData,
//         customerData: userData,
//       }    
//       // Retrieve current cart note and append new data
//       fetch("/cart.js", {
//         method: "GET",
//       })
//         .then((response) => response.json())
//         .then((cartData) => {
//           try {
//             currentNote = cartData.note;
//             if( email == null || email == "" || cartData.note.includes('"customerData":[]') || cartData.note.includes('"email":""'))
//               currentNote = "";
//           } catch (error) {
//             console.error("Error parsing current cart note:", error);
//           }
    
//           if (currentNote.includes("{") && currentNote.includes("}")) {
//             //alert("entered if");
//             var noteStr = currentNote.substring(
//               currentNote.indexOf("["),
//               currentNote.lastIndexOf("]")
//             ) + "]";
//             try {
//               currentData = JSON.parse(noteStr) || {};
//             } catch (error) {
//               console.error("Error parsing note. Empty json", error);
//             }
//           }
    
//           // Append new submission to existing data
//           if( email != null && email != "" )
//             console.log("push o/p =>",currentData.push(newData));
    
//           const updatedNote = JSON.stringify(currentData)
//           console.log("updatedNote", updatedNote)
    
//           fetch("/cart/update.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ note: updatedNote }),
//           })
//             .then((response) => {
//               if (response.ok) {
//                 console.log("Cart note updated successfully");
    
//                 //alert("Cart note updated successfully!");
//                 const checkIcon = document.getElementById("check-icon-"+itemId + "-" + i);
    
//                 if( email != null && email != "" ){
//                   if( checkIcon.style.display == 'block')
//                     checkIcon.style.display = 'none';
//                   else
//                     checkIcon.style.display = 'block'
//                 }
//                 // console.log("updatedNote:", updatedNote)
//               } else {
//                 console.error(
//                   "Error updating cart note:",
//                   response.status,
//                   response
//                 );
//               }
//             })
//             .catch((error) => {
//               console.error("Error updating cart note:", error);
//             });
//         })
//         .catch((error) => {
//           console.error("Error retrieving cart data:", error);
//         });
//       }
//   // Create JSON object with email and first name pairs
// }